import {
  AddressSearchTabId,
  AddressSearchTabItem,
} from '~/components/component-library/AddressSearchInput/types'
import {
  TabsList,
  TabsRoot,
  TabsTrigger,
} from '~/components/component-library/Tabs'

type AddressSearchTabsProps = {
  tabs: AddressSearchTabItem[]
  activeTab: AddressSearchTabId
  onTabChange: (tab: AddressSearchTabId) => void
}

export const AddressSearchTabs = ({
  tabs,
  activeTab,
  onTabChange,
}: AddressSearchTabsProps) => (
  <TabsRoot value={activeTab}>
    <TabsList variant="dense">
      {tabs.map(({ id, label }) => (
        <TabsTrigger
          key={id}
          value={id}
          // Focus stays in the search input; clicking a tab must not blur it.
          tabIndex={-1}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onTabChange(id)}
        >
          {label}
        </TabsTrigger>
      ))}
    </TabsList>
  </TabsRoot>
)

AddressSearchTabs.displayName = 'AddressSearchTabs'
